import React from 'react'
import {Checkbox, FormControlLabel, TextField} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  return (
    <>
      <TextField
        id="standard-number"
        label="Decimal Places*"
        type="number"
        variant="outlined"
        className="ap-textfield"
        value={data?.decimal_places}
        onChange={(e, value) => onChange(e, 'decimal_places')}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{min: 0}}
        style={{width: 200, marginTop: 16}}
      />
      <br />
      <TextField
        required
        id="standard-required"
        value={data?.delimiter}
        variant="outlined"
        className="ap-textfield"
        onChange={(e, value) => {
          if (e.target.value.length <= 1) {
            onChange(e, 'delimiter')
          }
        }}
        label="Delimiter"
        defaultValue=""
        style={{width: 200, marginTop: 16}}
      />
      <br />
      <FormControlLabel
        style={{marginBottom: 0}}
        control={
          <Checkbox
            onClick={e => onChange(e, 'allow_negative', !(data?.allow_negative || false))}
            size="small"
            checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
            checked={data?.allow_negative || false}
            name="required"
          />
        }
        label="Allow negative"
      />
      <br />
      <FormControlLabel
        style={{marginBottom: 0}}
        control={
          <Checkbox
            onClick={e => onChange(e, 'allow_scanning', !(data?.allow_scanning || false))}
            size="small"
            checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
            checked={data?.allow_scanning || false}
            name="required"
          />
        }
        label="Barcode Scanner?"
      />
      <br />
      {Number(data?.decimal_places) === 0 && (
        <TextField
          id="standard-number"
          label="Leading zeros"
          type="number"
          variant="outlined"
          inputProps={{min: 0}}
          className="ap-textfield"
          value={data?.total_numeric_digits}
          onChange={(e, value) => onChange(e, 'total_numeric_digits')}
          InputLabelProps={{
            shrink: true,
          }}
          style={{width: 200, marginTop: 16}}
        />
      )}
    </>
  )
}

export default FTextField
